import { render, staticRenderFns } from "./PolicyStatusCheckbox.vue?vue&type=template&id=c59541ac"
import script from "./PolicyStatusCheckbox.vue?vue&type=script&lang=ts"
export * from "./PolicyStatusCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./PolicyStatusCheckbox.vue?vue&type=style&index=0&id=c59541ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports